import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { datesHelper } from "@/shared/utils";
import { wsfScheduleApiMeta } from "../apiMeta";
import {
  type RoutesByTripDateAndTerminalsInput,
  routesByTripDateAndTerminalsInputSchema,
} from "./shared/routes.input";
import { type Route, routeSchema } from "./shared/routes.output";

/**
 * Metadata for the fetchRoutesByTripDateAndTerminals endpoint
 */
export const routesByTripDateAndTerminalsMeta = {
  functionName: "fetchRoutesByTripDateAndTerminals",
  endpoint: "/routes/{TripDate}/{DepartingTerminalID}/{ArrivingTerminalID}",
  inputSchema: routesByTripDateAndTerminalsInputSchema,
  outputSchema: routeSchema.array(),
  sampleParams: {
    TripDate: datesHelper.tomorrow(),
    DepartingTerminalID: 1,
    ArrivingTerminalID: 10,
  },
  endpointDescription: "List routes matching terminal pair for specified date.",
} satisfies EndpointMeta<RoutesByTripDateAndTerminalsInput, Route[]>;

/**
 * Fetch function for retrieving routes matching terminal pair for specified date
 */
const { fetch, useHook } = createFetchAndHook<
  RoutesByTripDateAndTerminalsInput,
  Route[]
>({
  api: wsfScheduleApiMeta,
  endpoint: routesByTripDateAndTerminalsMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/routes.endpoints").routesGroup.cacheStrategy,
});

/**
 * Fetch function for retrieving routes matching terminal pair for specified date
 */
export const fetchRoutesByTripDateAndTerminals: FetchFactory<
  RoutesByTripDateAndTerminalsInput,
  Route[]
> = fetch;

/**
 * React Query hook for retrieving routes matching terminal pair for specified date
 */
export const useRoutesByTripDateAndTerminals: HookFactory<
  RoutesByTripDateAndTerminalsInput,
  Route[]
> = useHook;
